import * as types from './types';

export const setSchoolReleaseInfoLoading = (isLoading) => ({
  type: types.SCHOOL_RELEASE_INFO_SET_LOADING,
  isLoading
});

export const getSchoolReleaseInfoData = () => ({
  type: types.SCHOOL_RELEASE_INFO_GET_DATA
});

export const setSchoolReleaseInfoData = (releaseInfo) => ({
  type: types.SCHOOL_RELEASE_INFO_SET_DATA,
  releaseInfo
});

export const resetSchoolReleaseInfoData = () => ({
  type: types.SCHOOL_RELEASE_INFO_RESET_DATA
});

export const setReleaseSeenBySchoolUser = (releaseId) => ({
  type: types.SCHOOL_RELEASE_INFO_SET_RELEASE_SEEN_BY_SCHOOL_USER,
  releaseId
});



// WEBPACK FOOTER //
// ./src/actions/school-release-info/index.js